const KEY = "yarn-open-spoilers-v1";

let open: ReadonlySet<string> | null = null;
const listeners = new Set<() => void>();

function read(): ReadonlySet<string> {
  if (open === null) {
    try {
      const saved: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
      open = new Set(Array.isArray(saved) ? saved.filter((id) => typeof id === "string") : []);
    } catch {
      open = new Set();
    }
  }
  return open;
}

/** Whether this reader has chosen to see this book's spoilers. */
export const bookSpoilersOpen = (bookId: string): boolean => read().has(bookId);

export function setBookSpoilersOpen(bookId: string, isOpen: boolean): void {
  const next = new Set(read());
  if (isOpen) {
    next.add(bookId);
  } else {
    next.delete(bookId);
  }
  open = next;
  try {
    localStorage.setItem(KEY, JSON.stringify([...next]));
  } catch {
    // It still holds until the page closes.
  }
  listeners.forEach((listener) => {
    listener();
  });
}

export function onBookSpoilersChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
